import $ from 'jquery';

class SiteHeader{

    constructor(){

        this.scroll_top = null;

        this.headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim());

        this.mobileBreakPoint = getComputedStyle(document.documentElement).getPropertyValue('--mobile-breakpoint').trim();

        this.mediaMobileBreakPoint = window.matchMedia(`(width < ${this.mobileBreakPoint})`);

        this.toggleSubmenu = $(".toggle-sub-menu");

        this.showMobileMenu = $(".hamburger-menu");

        this.hideMobileMenu = $(".hide-mobile-nav");

        this.mobileNavList = $(".navigation-list-mobile");

        this.navigationOverlay = $(".navigation-overlay");

        this.addImages();

        this.addScrollTop();

        this.events();

    }

    events(){

        $(this.mediaMobileBreakPoint).on('change', (e) => {

            this.hideMobileNav();
     
        });

        $(window).on('scroll', () =>{

            this.scrollCheck();

        });

        $(this.scroll_top).on("click", ()=>{

            this.animateScroll( $("body") );
			
		});

        this.toggleSubmenu.on('click', function(){

            if( $(this).siblings(".sub-menu").css("display") == "none"){

                $(".sub-menu").css("display","none");

                $(this).siblings(".sub-menu").css("display","block");

            }else{

                $(this).siblings(".sub-menu").css("display","none");

            }

        });
     
        this.showMobileMenu.on('click', () =>{

            this.showMobileNav();


        });

        this.hideMobileMenu.on('click', () =>{

            this.hideMobileNav();

                   
        });

        this.navigationOverlay.on('click', ()=>{
             
            this.hideMobileNav();

        });

        $("#all-listings").on('click', ()=>{

			this.animateScroll($("#listings"));			
			
		});

        $("#contact-button").on('click', ()=>{

            this.animateScroll($("#contact-form"));

        });
        
    }

    addImages(){
        $(".utility-icon-search").html(this.createSearchIcon( ));
        $(".utility-icon-cart").html(this.createCartIcon( ));
        $(".utility-icon-account").html(this.createAccountIcon( ));

    }

    animateScroll(target){

        $('html, body').animate({
            scrollTop: $(target).offset().top - this.headerHeight
        }, 750);

    }

    hideMobileNav(){

        $(this.mobileNavList).removeClass("show-navigation-list-mobile");

        $(this.navigationOverlay).removeClass("show-navigation-overlay"); 
    }

    showMobileNav(){

        $(this.mobileNavList).addClass("show-navigation-list-mobile");

        $(this.navigationOverlay).addClass("show-navigation-overlay");

    }

    createSearchIcon( ){

        var html = `

            <svg viewBox="0 -960 960 960">
                <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 
                83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/>
            </svg>
        
        `;

        
        return html;
            
    }

    createCartIcon( ){

        var html = `



            <svg viewBox="0 -960 960 960">
                <path d="M280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 
                23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM246-720l96 200h280l110-200H246Zm-38-80h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 
                31T622-440H324l-44 80h480v80H280q-45 0-68-39.5t-2-78.5l54-98-144-304H40v-80h130l38 80Zm134 280h280-280Z"/>
            </svg>




        `;
        
        return html;
            
    }

    createAccountIcon( ){

        var html = `

            <svg viewBox="0 -960 960 960">
                <path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 
                59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 
                0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 
                156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 
                43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z"/>
            </svg>    

        `;
        
        return html;
            
    }

    addScrollTop(){
		this.scroll_top = document.createElement('div');

		this.scroll_top.className = "scroll__top__button";

		$("body").append(this.scroll_top);

		this.scrollCheck();

	}

	scrollCheck( ){

		let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

		if(scrollTop > 100) {

			$(this.scroll_top).fadeIn("fast");

		}else{

			$(this.scroll_top).fadeOut("fast");

		}

/* 		if(scrollTop > 50) {

			document.body.style.setProperty("--header-height", "70px");

		}else{

			document.body.style.setProperty("--header-height", "80px");

		}		
 */
	}

}

export default SiteHeader;